import axios from 'axios';
import store from '@/plugins/store';
import App from '@/app';
import * as Sentry from '@sentry/browser';

export default function api(isAuthRequired = true) {
  const headers = { 'Content-Type': 'application/json' };

  if (['admin', 'worker'].indexOf(store.state.users.role) !== -1 && store.state.users.chosen_client) {
    headers.Client = store.state.users.chosen_client.id;
  }

  if (isAuthRequired) {
    const { token } = store.state.users;

    if (token === null || token.length === 0) {
      store.dispatch('LOGOUT');

      return Promise.reject();
    }

    headers.Authorization = `Bearer ${token}`;
  }

  const instance = axios.create({
    baseURL: App.api_url,
    headers,
  });

  instance.interceptors.response.use((response) => {
    if (!store.state.users.authenticated) {
      window.location.reload();
    }

    return response;
  }, (error) => {
    if (App.ENV_MODE === 'production') {
      Sentry.captureException(error);
    }

    if (error.response.status === 401) {
      store.dispatch('nt_set_notification', {
        type: 'error',
        message: 'Your session has expired.',
      });

      store.commit('set_authenticated', false);
    }

    return Promise.reject(error);
  });

  return instance;
}
